import React from 'react';
import { Plus } from 'lucide-react';
import {
  planCreateYourOwnCompactButtonClass,
  planCreateYourOwnFloatingButtonClass,
} from '../planFloatingActionsTheme';

interface CurriculumAddMenuProps {
  onOpenCreateYourOwnWizard: () => void;
  className?: string;
  variant?: 'default' | 'compact';
}

export function CurriculumAddMenu({
  onOpenCreateYourOwnWizard,
  className = '',
  variant = 'default'
}: CurriculumAddMenuProps) {
  const isCompact = variant === 'compact';
  const buttonClasses = isCompact
    ? `${planCreateYourOwnCompactButtonClass} ${className}`
    : `${planCreateYourOwnFloatingButtonClass} ${className}`;

  return (
    <button type="button" className={buttonClasses} onClick={onOpenCreateYourOwnWizard}>
      <Plus size={isCompact ? 14 : 20} />
      <span>{isCompact ? 'Create Your Own Topic(s)' : 'Add'}</span>
    </button>
  );
}
